import { ItemEntity } from '@entities/Item/Types';
import { ApiResult } from '@shared/Interfaces/Api/ApiResult';
import { CartAddItemResponse } from './Interfaces/CartAddItemResponse';
import { ItemsPayload } from '../CustomProjects/Interfaces/ProjectAddItemPayload';
import { CustomProjectEntity } from '@entities/CustomProject/Types';
import { AddToCartPayload } from './Interfaces/CartAddItemsPayload';
import ApiRequest from '../../Decorators/ApiRequest';
import { API_DEFAULT_HEADERS } from '@configs/ApiDefaultHeaders';

const BASE_URL = import.meta.env.VITE_BASE_URL_CUSTOMER;

export class CartGateway {
    async addToCart(
        items: ItemEntity[],
        project: CustomProjectEntity
    ): Promise<ApiResult<CartAddItemResponse>> {
        const itemsPayload: ItemsPayload[] = items.map(item => ({
            qty: item.qty ?? 0,
            id: item.id,
        }));

        const body: AddToCartPayload = {
            coordinates: {
                latitude: project.address?.latitude ?? '',
                longitude: project.address?.longitude ?? '',
            },
            items: itemsPayload,
        };

        try {
            const response = await ApiRequest(`${BASE_URL}/cart`, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: API_DEFAULT_HEADERS,
            });

            const json = await response.json();
            if (response.status !== 200 && response.status !== 201) {
                return {
                    error: true,
                    message: 'Failed to add items to cart',
                };
            }

            return {
                error: false,
                data: json as CartAddItemResponse,
            };
        } catch (error) {
            return {
                error: true,
                message: `Error: ${error}`,
            };
        }
    }
}
